import { AmplifyService } from './services/amplify/AmplifyService';

export const amplifyService = new AmplifyService();

export enum AppBootstrapStatus {
  SUCCESS = 'Application Loaded Successfully.',
  AMPLIFY_ERROR = 'Error with AWS Amplify Configuration.',
  AUTHENTICATING = 'Authenticating User on AWS Cognito User Pool.',
  AUTH_ERROR = 'User Authentication Error.',
}

export const AppBootstrap = async (): Promise<AppBootstrapStatus> => {
  let promise = Promise.resolve(AppBootstrapStatus.SUCCESS);

  try {
    const { href } = window.location;
    const isAuthCallback = href.includes('code=') || href.includes('state=');

    await amplifyService.configure();

    if (isAuthCallback) {
      let resolveRef!: (status: AppBootstrapStatus) => void;
      const sourceFetch = window.fetch;

      window.fetch = function (...args: Parameters<typeof fetch>) {
        return sourceFetch.apply(this, args).then((response) => {
          if (response.url.includes(amplifyService.getAuthenticationDomain())) {
            window.fetch = sourceFetch;
            resolveRef(response.ok ? AppBootstrapStatus.SUCCESS : AppBootstrapStatus.AUTH_ERROR);
          }
          return response;
        }).catch((error) => {
          const [url] = args;
          if (typeof url === 'string' && url.includes(amplifyService.getAuthenticationDomain())) {
            window.fetch = sourceFetch;
            resolveRef(AppBootstrapStatus.AUTH_ERROR);
          }
          throw error;
        });
      };

      promise = new Promise((resolve) => { resolveRef = resolve; });
    }

    const user = await amplifyService.getCurrentUser();

    if (!isAuthCallback && !user) {
      await amplifyService.signIn();
      return AppBootstrapStatus.AUTHENTICATING;
    }
  } catch {
    return AppBootstrapStatus.AMPLIFY_ERROR;
  }

  return promise;
};
